<template>
  <div class="options-menu-container">
    <div class="dropdown-menu" @click.stop>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OptionsMenu',
  props: {
    buttons: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      isOpen: false,
    };
  },
  methods: {
    handleOutsideClick(event) {
      if (!this.$el.contains(event.target)) {
        this.$emit('closeMenu');
      }
    },
    handleOption() {
      this.$emit('closeMenu');
    }
  },
  mounted() {
    document.addEventListener('click', this.handleOutsideClick);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleOutsideClick);
  }
};
</script>

<style scoped>
.options-menu-container {
  position: relative;
  display: inline-block;
}

.options-button {
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
}

.dropdown-menu {
  position: absolute;
  top: 10px;
  right: 0;
  background-color: #fff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  min-width: 200px;
  padding: 10px;
  z-index: 10000;
}

.dropdown-menu button {
  background-color: #fff;
  border: none;
  padding: 8px 12px;
  width: 100%;
  text-align: left;
  cursor: pointer;
}

.dropdown-menu button:hover {
  background-color: #f4f4f4;
}
</style>
